// create by nieshu on 2018/11/6
// utils
import Plugins from '@/utils/plugins'
import Util from '@/utils/util'

import Vue from 'vue'
// api
import NewApplyApi from '@/api/newApply.api'
// util
// import querystring from 'querystring'
// store
import {mapState, mapMutations} from 'vuex'
const pageScale = window.screen.height / window.screen.width
const FunMixin = {
  // created () {
  //   console.log('混入对象的钩子被调用')
  // }
  data() {
    return {
      mixinData: {
        showConfirm: false,
        pageScale,
        pageScaleValue: Util.judgePageSize(pageScale)
      }
    }
  },
  computed: {
    ...mapState([
      'hasHeader',
      'navigateTitle',
      'navigateStyle'
    ])
  },
  methods: {
    m_scroll(type) {
      document.body.style.overflow = type ? '' : 'hidden'
    },
    m_isAndroid() {
      return Plugins.systemDefer.promise.then(res => {
        return res.isAndroid
      })
    },
    m_isIOS() {
      return Plugins.systemDefer.promise.then(res => {
        return res.isIOS
      })
    },
    m_isIphoneX() {
      return Plugins.systemDefer.promise.then(res => {
        return res.isIphoneX
      })
    },
    async m_goPagesWithQ(name, query) {
      await this.m_clickDebounce('goPages')
      this.$router.push({name, query})
    },
    async m_goPages(name, params) {
      await this.m_clickDebounce('goPages')
      this.$router.push({name, params})
    },
    async m_replacePages(name, param) {
      await this.m_clickDebounce('goPages')
      let params = {
        replace: true,
        ...param
      }
      this.$router.replace({name, params})
    },
    async m_replacePagesWithQ(name, query) {
      await this.m_clickDebounce('goPages')
      let params = {
        replace: true,
        ...query
      }
      this.$router.replace({name, query: params})
    },
    m_backHome() {
      let len = -(this.$routeHis.length - 1)
      console.log('back home', this.$routeHis, len)
      Vue.prototype.$routeHis = ''
      this.$router.go(len)
    },
    m_relaunch(name = 'goodsDetail') {
      let len = -(this.$routeHis.length - 2)
      Vue.prototype.$routeHis = ''
      this.$router.go(len)
      setTimeout(() => {
        this.$router.replace({name, params: {}})
      }, 100);
    },
    // m_changeHeaderBG(color) {
    //   if (this.bus.$refs.naviHeader) {
    //     setTimeout(() => {
    //       this.bus.$refs.naviHeader.$emit('changeHeaderBG', color)
    //     })
    //   }
    // },
    m_setPageTitle(title) {
      document.title = title
    },
    m_showConfirm(data) {
      return new Promise(re => {
        setTimeout(() => {
          let self = this
          this.mixinData.showConfirm = true
          this.bus.$refs.confirm.$emit('showConfirm', {
            confirmHandler() {
              self.mixinData.showConfirm = false
              re(true)
            },
            cancelHandler() {
              self.mixinData.showConfirm = false
              re(false)
            },
            hasConfirm() {
              self.mixinData.showConfirm = false
            },
            ...data
          })
        })
      })
    },
    m_showToast(data) {
      setTimeout(() => {
        this.bus.$refs.toast.$emit('toast', data)
      })
    },
    m_showLoading() {
      setTimeout(() => {
        this.bus.$refs.toast.$emit('loading')
      })
    },
    m_loadingClose() {
      setTimeout(() => {
        this.bus.$refs.toast.$emit('loadingClose')
      })
    },
    m_clickDebounce(key, time = 800) {
      key = key + '_debounce'
      // console.log('click debounce', key, this.mixinData[key])
      return new Promise((re, rj) => {
        if (this.mixinData[key]) {
          rj(key)
        } else {
          this.mixinData[key] = true
          setTimeout(() => {
            this.mixinData[key] = false
          }, time)
          re()
        }
      }).catch(e => {
        console.warn('warn click debounce ', e)
      })
    },
    m_awaitTime(time = 1000) {
      return new Promise(re => {
        setTimeout(() => {
          re()
        }, time)
      })
    },
    async m_customService() {
      this.m_showLoading()
      try {
        const isObject = (value) => { return Object.prototype.toString.call(value) === '[object Object]' }
        const objData = await NewApplyApi.customService()
        const customServiceBaseUrl = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'stag' ? 'https://channel.fowo.com/embeded/im/iframe-h5.html?' : 'https://channel-gduat.fowo.com/embeded/im/iframe-h5.html?'
        objData.param_query = isObject(objData.param_query) ? JSON.stringify(objData.param_query) : objData.param_query
        objData.param_service_visitor = isObject(objData.param_service_visitor) ? JSON.stringify(objData.param_service_visitor) : objData.param_service_visitor
        objData.param_account = isObject(objData.param_account) ? JSON.stringify(objData.param_account) : objData.param_account
        let paramUrl = `paramServiceVisitor=${objData.param_service_visitor}&paramAccount=${objData.param_account}&paramServiceChat=${objData.param_service_chat}&questionFlag=${objData.question_flag}&paramQuery=${objData.param_query}`
        let repdata = paramUrl.replace(/"/g, "'")
        paramUrl = encodeURI(repdata)
        const webViewUrl = customServiceBaseUrl + `tenantToken=${objData.tennat_token}&siteId=${objData.site_id}&skillsetId=${objData.skill_set_id}&customFlag=1&` + paramUrl
        location.href = webViewUrl
        console.log('webViewUrl', webViewUrl)
      } catch (e) {
        console.error(e)
      } finally {
        this.m_loadingClose()
      }
    },
    ...mapMutations([
      'setHasHeader',
      'setNavigateTitle',
      'setNavigateStyle'
    ])
  },
  beforeRouteEnter(to, from, next) {
    if (!Vue.prototype.$routeHis) Vue.prototype.$routeHis = []
    if (to.params.replace || to.query.replace) {
      Vue.prototype.$routeHis.pop()
      Vue.prototype.$routeHis.push(to.name)
    } else if (Vue.prototype.$routeHis.indexOf(to.name) === -1) {
      Vue.prototype.$routeHis.push(to.name)
    } else {
      Vue.prototype.$routeHis.pop()
    }
    next()
  },
  destroyed() {
    if (this.mixinData.showConfirm) {
      this.bus.$refs.confirm.$emit('hideConfirm')
    }
  }
}
export default FunMixin
